<template>
  <modal
    class="city-confirmation-modal"
    :visible="$city.isCityConfirmationShown"
    allow-close
    @on-close="$city.hideCityConfirmation()"
  >
    <city-confirmation
      @choose="choose"
    />
  </modal>
</template>

<script>
import CityConfirmation from '@/components/header/city-confirmation';

export default {
  name: 'city-confirmation-modal',

  components: {
    CityConfirmation
  },

  methods: {
    choose(answer) {
      this.$city.$emit('city-confirmation', answer);
    }
  }
};
</script>

<style lang="scss">
div.city-confirmation-modal {
  z-index: 100;
}

@include breakpoint("tablet") {
  .city-confirmation-modal {
    .modal-content {
      width: 320px;
    }
  }
}

@include breakpoint("desktop") {
  .city-confirmation-modal {
    .modal-content {
      width: 440px;
      padding: 48px 40px;
    }
  }
}
</style>